import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {
    IGenerateActivityFormData
} from '../../../../contract-control/modals/bulk-upload-modal/ai-generate-activity/ai-generate-activity.component';
import {IUploadMapping} from '../../../../contract-control/modals/bulk-upload-modal/steps/match-columns-step/match-columns-step.component';
import {
    IImportPDFMapping
} from '../../../../contract-control/modals/bulk-upload-modal/steps/match-contract-cards-step/match-contract-cards-step.component';
import * as BulkUploadActions from './documents-bulk-upload.actions';
import {DocumentBulkUploadStepEnum} from './documents-bulk-upload.reducers';
import * as BulkUploadSelectors from './documents-bulk-upload.selectors';

@Injectable({providedIn:'root'})
export class DocumentsBulkUploadFacade{
    currentStep$:Observable<DocumentBulkUploadStepEnum> = this._store.select(BulkUploadSelectors.currentStep);
    firstLineTitles$:Observable<0 | 1> = this._store.select(BulkUploadSelectors.firstLineTitles);
    uploadId$ = this._store.select(BulkUploadSelectors.uploadId);
    previewData$ = this._store.select(BulkUploadSelectors.previewData);
    previewColumns$ = this._store.select(BulkUploadSelectors.previewColumns);
    mergeOrganisations$ = this._store.select(BulkUploadSelectors.mergeOrganisations);
    importedSummary$ = this._store.select(BulkUploadSelectors.importedSummary);
    unimportedSummary$ = this._store.select(BulkUploadSelectors.unimportedSummary);
    failedImports$ = this._store.select(BulkUploadSelectors.failedImports).pipe(map(x=> JSON.parse(JSON.stringify(x))));
    firstRowData$ = this._store.select(BulkUploadSelectors.firstRowData);

    isUpdateMappingRequestInProgress$= this._store.select(BulkUploadSelectors.isUpdateMappingRequestInProgress);
    isSkipStepLoading$= this._store.select(BulkUploadSelectors.isSkipStepLoading);
    isFirstLineLoading$= this._store.select(BulkUploadSelectors.isFirstLineLoading);
    isPotentialMappingLoading$= this._store.select(BulkUploadSelectors.isPotentialMappingLoading);
    cardColumns$ = this._store.select(BulkUploadSelectors.cardColumns);


    constructor(private _store: Store) {
    }

    /**
     * Function for next step
     */
    nextStep():void{
        this._store.dispatch(BulkUploadActions.nextStep());
    }

    prevStep():void{
        this._store.dispatch(BulkUploadActions.prevStep());
    }

    firstLineTitlesChange(firstLineTitles: 0 | 1) {
        this._store.dispatch(BulkUploadActions.updateFirstLineTitles({firstLineTitles:firstLineTitles} ));
    }

    onMergeOrganisationsChange(mergeOrganisations: boolean) {
        this._store.dispatch(BulkUploadActions.mergeOrganisationsChanged({mergeOrganisations}));
    }

    onTableDataChanged(items: IImportPDFMapping[]) {
        this._store.dispatch(BulkUploadActions.failedImportsChanged({items}));
    }

    skip() {
        this._store.dispatch(BulkUploadActions.skipCSVImportClicked())
    }

    updateUploadId(id: number) {
        this._store.dispatch(BulkUploadActions.updateUploadId({id}))
    }

    fetchFirstRow() {
        this._store.dispatch(BulkUploadActions.fetchFirstRow())
    }

    fetchPotentialMappings() {
        this._store.dispatch(BulkUploadActions.fetchPotentialMappings());
    }

    onMappingChange(mapping: IUploadMapping[]) {
        this._store.dispatch(BulkUploadActions.mappingChanged({mapping}));
    }


    saveMapping() {
        this._store.dispatch(BulkUploadActions.saveMappings());
    }

    importXLS() {
        this._store.dispatch(BulkUploadActions.importXLS());
    }


    onImportPDFClick() {
        this._store.dispatch(BulkUploadActions.importPDF());
    }

    setImportSettings(importSettings: IGenerateActivityFormData) {
        this._store.dispatch(BulkUploadActions.setImportSettings({importSettings}));
    }

    saveImportSettings() {
        this._store.dispatch(BulkUploadActions.saveImportSettings());
    }

    updateFirstRowAndFetch($event: 0 | 1) {
        this.firstLineTitlesChange($event);
        this._store.dispatch(BulkUploadActions.fetchFirstRow());
    }
}
